import React from 'react';
import './Blogs.css'; // 👈 Create this for styling
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import FooterNew from '../Layout/FooterNew';

const Blogs = () => {
  const blogData = [
    {
      title: 'Prime Commercial Properties Available Near Sikar Road',
      desc: 'A Smart Investment Opportunity',
      date: 'October 21, 2024',
      image: 'https://cdn.corporatefinanceinstitute.com/assets/real-estate.jpeg',
      link: 'affordable-commercial-property-for-sale.html',
    },
    {
      title: 'Guide to Discovering the Perfect Commercial Shops for Sale Nearby',
      desc: 'A Comprehensive Guide',
      date: 'October 31, 2024',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjn7mbWlHkzGfpy2lawCw1ugkHUo364wFJNg&s',
      link: 'best-commercial-shops-for-sale-near-you.html',
    },
   
    {
      title: 'How Do I Find RERA Certified Projects in Jaipur?',
      desc: 'A Step-by-Step Guide',
      date: 'November 11, 2024',
      image: 'https://rankawatgroup.com/blog/assets/images/blog/RERA.jpg',
      link: 'RERA-certified-projects-in-jaipur.html',
    },
  ];

  return (
    <div>
        <Header/>
   
    <div className="blog-wrapper">
      <div className="page-banner-area">
        <div className="container">
          <div className="page-banner-content">
            <h1><b>Our Blogs</b></h1>
            <ul className="list">
              <li><a href="/">Home</a></li>
              <li>Blog</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="blog-area">
        <div className="container">
          <div className="blog-grid">
            {blogData.map((item, index) => (
              <div className="blog-card" key={index}>
                <div className="blog-image">
                  <a href={item.link}>
                    <img src={item.image} alt="blog" />
                  </a>
                </div>
                <div className="blog-content">
                  <ul className="meta">
                    <li><i className="ri-calendar-2-line"></i> {item.date}</li>
                  </ul>
                  <h3><a href={item.link}>{item.title}</a></h3>
                  {item.desc && <p>{item.desc}</p>}
                </div>
              </div>
            ))}
          </div>

          {/* <div className="pagination-area">
            <div className="nav-links">
              <a href="#" className="prev page-numbers"><i className="ri-arrow-left-s-line"></i></a>
              <span className="page-numbers current">1</span>
              <a href="#" className="page-numbers">2</a>
              <a href="#" className="page-numbers">3</a>
              <a href="#" className="next page-numbers"><i className="ri-arrow-right-s-line"></i></a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
    <Footer/>
    <FooterNew/>
    </div>
  );
};

export default Blogs;
